import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getCategoryTypesCount} from "../../store/reducers/CategoryTypesSlice";
import {Option} from "../common/form/ElogSelect";
import {getContacts, reseGetContactsStatus, setLanguage, setType} from "../../store/reducers/ContactsSlice";
import {RequestStatus} from "../../utils/Enums";
import { useNavigate } from 'react-router-dom';
import {getCountries} from "../../store/reducers/CountriesSlice";
import {Tab} from "../../models/Tab";

interface SendSMSStep1Props {
}

const TABS: Tab[] = [
    {
        identifier: 'vendors',
        name: 'Hankijad'
    },
    {
        identifier: 'clients',
        name: 'Kliendid'
    },
];

const languageOptions: Option[] = [
    { value: 'est', label: 'Eesti' },
    { value: 'eng', label: 'Inglise' },
    { value: 'fin', label: 'Soome' },
    { value: 'swe', label: 'Rootsi' },
];

export const SendSMSStep1: React.FC<SendSMSStep1Props> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState<Tab>(() => {
        const storedActiveTab = sessionStorage.getItem('activeTab');
        return storedActiveTab ? JSON.parse(storedActiveTab) : TABS[0];
    });
    const [selectedIds, setSelectedIds] = useState<number[]>(() => {
        const storedSelectedIds = sessionStorage.getItem('selectedIds');
        return storedSelectedIds ? JSON.parse(storedSelectedIds) : [];
    });
    const [selectedLanguage, setSelectedLanguage] = useState<Option>(() => {
        const storedSelectedLanguage = sessionStorage.getItem('selectedLanguage');
        return storedSelectedLanguage ? JSON.parse(storedSelectedLanguage) : languageOptions[0];
    });

    const countriesState = useAppSelector((state) => state.countries);
    const countryOptions: Option[] = [
        { value: "0", label: "Kõik" },
        ...countriesState.countries.map(country => ({ value: String(country.id), label: country.name }))
    ];

    const [selectedCountry, setSelectedCountry] = useState<Option>(() => {
        const storedSelectedCountry = sessionStorage.getItem('selectedCountry');
        return storedSelectedCountry ? JSON.parse(storedSelectedCountry) : countryOptions[0];
    });

    const categoryTypesState = useAppSelector(state => state.categoryTypes);
    const contactsState = useAppSelector(state => state.contacts);

    const getContactsRequest = contactsState.getContactsStatus;

    useEffect(() => {

        if ( getContactsRequest === RequestStatus.Success ) {
            dispatch(reseGetContactsStatus());
            navigate('/send-sms/2')
        }

    },[getContactsRequest])

    useEffect(() => {
        dispatch(getCountries());
    }, []);

    useEffect(() => {
        if (activeTab) {
            dispatch(getCategoryTypesCount({ type: activeTab.identifier, language: selectedLanguage.value, country: selectedCountry.value }));
            dispatch(setType(activeTab.identifier));
        }
    }, [activeTab, selectedLanguage]);

    useEffect(() => {
        if (getContactsRequest === RequestStatus.Success) {
            dispatch(reseGetContactsStatus());
        }
    }, [getContactsRequest]);

    const handleTabClick = (tab: Tab) => {
        setActiveTab(tab);
    };

    const search = () => {
        dispatch(getContacts({
            type: activeTab.identifier,
            language: selectedLanguage.value,
            categories: selectedIds,
            country: selectedCountry.value,
            page: 1
        }));
    }

    const handleCheckboxChange = (categoryId: number) => {

        let newIds = [];

        if (selectedIds.includes(categoryId)) {
            newIds = selectedIds.filter(id => id !== categoryId)
        } else {
            newIds = [...selectedIds, categoryId];
        }
        setSelectedIds(newIds);
        sessionStorage.setItem('selectedIds', JSON.stringify(newIds));
    };

    const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        const selectedOption = languageOptions.find((option) => option.value === selectedValue);
        if (selectedOption) {
            dispatch(setLanguage(selectedOption.value));
            setSelectedLanguage(selectedOption);
            sessionStorage.setItem('selectedLanguage', JSON.stringify(selectedOption));
        }
    };

    const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        const selectedOption = { value: selectedValue, label: event.target.selectedOptions[0].text };
        if (selectedOption) {
            setSelectedCountry(selectedOption);
            sessionStorage.setItem('selectedCountry', JSON.stringify(selectedOption));
        }
    }

    const handleReset = () => {
        //sessionStorage.removeItem('activeTab');
        sessionStorage.removeItem('selectedIds');
        //sessionStorage.removeItem('selectedLanguage');
        //sessionStorage.removeItem('selectedCountry');
        setSelectedIds([]);
        //setSelectedLanguage(languageOptions[0]);
        //setSelectedCountry({ value: "0", label: "Kõik" });
    };

    return (
        <LoggedInView fullWidth={false}>
            <h1>Saada SMS</h1>
            <ul className="tabs clear" style={{width: '100%'}}>
                {TABS.map(tab => (
                    <li key={'tab' + tab.identifier} className={activeTab === tab ? 'active' : ''}>
                        <a href="Javascript:;" onClick={() => handleTabClick(tab)}>{tab.name}</a>
                    </li>
                ))}
                <li>
                    <button onClick={handleReset} style={{marginLeft: '20px', border: '1px solid black', paddingLeft: '10px', paddingRight: '10px'}}>Reset</button>
                </li>
            </ul>
            <div>
                <label htmlFor="languageSelect">Keel:</label>
                <select id="languageSelect" value={selectedLanguage.value} onChange={handleLanguageChange}>
                    {languageOptions.map((option) => (
                        <option key={'option' + option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            {categoryTypesState.categoryTypesCount.map(category => (
                <div className="form">
                    <div key={'category' + category.id}>
                        <h2><span>{category.name}</span></h2>
                        {category?.categories?.map(cat => (
                            <React.Fragment key={'cat' + cat.id}>
                                <label htmlFor={`group_${cat.id}`}>{cat.name} ({cat.count})</label>
                                <input
                                    id={`group_${cat.id}`}
                                    type="checkbox"
                                    name="categories[]"
                                    value={cat.id}
                                    checked={selectedIds.includes(cat.id)}
                                    onChange={() => handleCheckboxChange(cat.id)}
                                />
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            ))}
            {activeTab.identifier === 'clients' &&
            <div>
              <label htmlFor="languageSelect">Riik:</label>
              <select id="countrySelect" value={selectedCountry.value} onChange={handleCountryChange}>
                  {countryOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                          {option.label}
                      </option>
                  ))}
              </select>
            </div>
            }
            <div className="action clear">
                <p>
                    <button type="submit" onClick={search}><span><strong>Otsi</strong></span>
                    </button>
                </p>
            </div>
        </LoggedInView>
    )
}

export default SendSMSStep1;